import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import apparelIcon from '../../../images/insight360/360-apparel-icon.png';
import autoIcon from '../../../images/insight360/360-auto-icon.png';
import cellphonesIcon from '../../../images/insight360/360-cellphones-icon.png';
import consumerPrivacyIcon from '../../../images/insight360/360-consumer-privacy-icon.png';
import dietHealthIcon from '../../../images/insight360/360-diet-health-icon.png';
import environmentIcon from '../../../images/insight360/360-environment-icon.png';
import foodIcon from '../../../images/insight360/360-food-icon.png';
import healthMedsIcon from '../../../images/insight360/360-health-meds-icon.png';
import internetIcon from '../../../images/insight360/360-internet-icon.png';
import mediaIcon from '../../../images/insight360/360-media-icon.png';
import personalFinanceIcon from '../../../images/insight360/360-personal-finance-icon.png';
import prodPlcmntMoviesIcon from '../../../images/insight360/360-prod-plcmnt-movies-icon.png';
import prodPlcmntTvIcon from '../../../images/insight360/360-prod-plcmnt-tv-icon.png';
import shoppingIcon from '../../../images/insight360/360-shopping-icon.png';
import shoppingBehaviorIcon from '../../../images/insight360/360-shopping-behavior-icon.png';
import socInteractionIcon from '../../../images/insight360/360-soc-interaction-icon.png';
import socialMediaIcon from '../../../images/insight360/360-social-media-icon.png';
import techIcon from '../../../images/insight360/360-tech-icon.png';
import travelIcon from '../../../images/insight360/360-travel-icon.png';
import videoGameIcon from '../../../images/insight360/360-video-game-icon.png';
import homeIcon from '../../../images/insight360/360-home-icon.png';
import healthBeautyIcon from '../../../images/insight360/360-health-beauty-icon.png';
import diningIcon from '../../../images/insight360/360-dining-icon.png';
import cleaningProductsIcon from '../../../images/insight360/360-cleaning-products-icon.png';
import spanishIcon from '../../../images/insight360/360-spanish-language-icon.png';
import printMediaIcon from '../../../images/insight360/360-print-media-icon.png';
import petsIcon from '../../../images/insight360/360-pets-icon.png';
import lifestyleIcon from '../../../images/insight360/360-lifestyle-icon.png';
import tobaccoIcon from '../../../images/insight360/360-tobacco-icon.png';
// MRI Brands..
import mriBabyIcon from '../../../images/mri-icons/360-mri-baby-icon.png';
import mriBeveragesIcon from '../../../images/mri-icons/360-mri-beverages-icon.png';
import mriCandyIcon from '../../../images/mri-icons/360-mri-candy-icon.png';
import mriLeisureSportsIcon from '../../../images/mri-icons/360-mri-leisure-sports-icon.png';
import mriNewspaperIcon from '../../../images/mri-icons/360-mri-newspaper-icon.png';
import mriNonFoodProductsIcon from '../../../images/mri-icons/360-mri-non-food-products-icon.png';
import mriOccupationIcon from '../../../images/mri-icons/360-mri-occupation-icon.png';
import mriPersonalItemIcon from '../../../images/mri-icons/360-mri-personal-item-icon.png';
import mriPetsIcon from '../../../images/mri-icons/360-mri-pets-icon.png';
import mriTobaccoIcon from '../../../images/mri-icons/360-mri-tobacco-icon.png';
import mriRadioIcon from '../../../images/mri-icons/360-mri-tv-watching-icon.png';
import mriFinanceIcon from '../../../images/mri-icons/360-mri-finance-icon.png';
import mriBuyingStyleIcon from '../../../images/mri-icons/360-mri-buying-style-icon.png';
import mriHomeIcon from '../../../images/mri-icons/360-mri-home-icon.png';
import mriTelevisionIcon from '../../../images/mri-icons/360-mri-television-icon.png';
import mriTravelIcon from '../../../images/mri-icons/360-mri-travel-icon.png';


const iconComponents = [
  { id: '360ApparelIcon', selectedIcon: apparelIcon },
  { id: '360AutoIcon', selectedIcon: autoIcon },
  { id: '360CellphonesIcon', selectedIcon: cellphonesIcon },
  { id: '360ConsumerPrivacyIcon', selectedIcon: consumerPrivacyIcon },
  { id: '360DietHealthIcon', selectedIcon: dietHealthIcon },
  { id: '360EnvironmentIcon', selectedIcon: environmentIcon },
  { id: '360FoodIcon', selectedIcon: foodIcon },
  { id: '360HealthMedsIcon', selectedIcon: healthMedsIcon },
  { id: '360InternetIcon', selectedIcon: internetIcon },
  { id: '360MediaIcon', selectedIcon: mediaIcon },
  { id: '360PersonalFinanceIcon', selectedIcon: personalFinanceIcon },
  { id: '360ProdPlcmntMoviesIcon', selectedIcon: prodPlcmntMoviesIcon },
  { id: '360ProdPlcmntTvIcon', selectedIcon: prodPlcmntTvIcon },
  { id: '360ShoppingIcon', selectedIcon: shoppingIcon },
  { id: '360ShoppingBehaviorIcon', selectedIcon: shoppingBehaviorIcon },
  { id: '360SocInteractionIcon', selectedIcon: socInteractionIcon },
  { id: '360SocialMediaIcon', selectedIcon: socialMediaIcon },
  { id: '360TechIcon', selectedIcon: techIcon },
  { id: '360TravelIcon', selectedIcon: travelIcon },
  { id: '360VideoGameIcon', selectedIcon: videoGameIcon },
  { id: '360TobaccoIcon', selectedIcon: tobaccoIcon },
  { id: '360LifestyleIcon', selectedIcon: lifestyleIcon },
  { id: '360PetsIcon', selectedIcon: petsIcon },
  { id: '360PrintMediaIcon', selectedIcon: printMediaIcon },
  { id: '360SpanishLanguageIcon', selectedIcon: spanishIcon },
  { id: '360CleaningProductsIcon', selectedIcon: cleaningProductsIcon },
  { id: '360DiningIcon', selectedIcon: diningIcon },
  { id: '360HealthBeautyIcon', selectedIcon: healthBeautyIcon },
  { id: '360HomeIcon', selectedIcon: homeIcon },
  // Mri Brands Icons..
  { id: '360BabyIcon', selectedIcon: mriBabyIcon },
  { id: '360BeveragesIcon', selectedIcon: mriBeveragesIcon },
  { id: '360CandyIcon', selectedIcon: mriCandyIcon },
  { id: '360LeisureSportsIcon', selectedIcon: mriLeisureSportsIcon },
  { id: '360NewspaperIcon', selectedIcon: mriNewspaperIcon },
  { id: '360NonFoodProductsIcon', selectedIcon: mriNonFoodProductsIcon },
  { id: '360OccupationIcon', selectedIcon: mriOccupationIcon },
  { id: '360PersonalItemIcon', selectedIcon: mriPersonalItemIcon },
  { id: '360PersonalItemIcon', selectedIcon: mriPersonalItemIcon },
  { id: '360HhPetsIcon', selectedIcon: mriPetsIcon },
  { id: '360TobaccoProductsIcon', selectedIcon: mriTobaccoIcon },
  { id: '360RadioIcon', selectedIcon: mriRadioIcon },
  { id: '360TvWatchingIcon', selectedIcon: mriRadioIcon },
  { id: '360FinanceIcon', selectedIcon: mriFinanceIcon },
  { id: '360BuyingStyleIcon', selectedIcon: mriBuyingStyleIcon },
  { id: '360FinanceIcon', selectedIcon: mriFinanceIcon },
  { id: '360HomeImprovementIcon', selectedIcon: mriHomeIcon },
  { id: '360TelevisionIcon', selectedIcon: mriTelevisionIcon },
  { id: '360TravelPlanningIcon', selectedIcon: mriTravelIcon },
];

class ProfileTripleComparisionDetail extends Component {

  getImageIcon = imageKey => {
    const imageComponent = _.find(iconComponents, { id: imageKey });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    }
    return undefined;
  }

  render() {
    return (
      <div>
        {this.props.brandDetail !== undefined && (
          <div
            className="attitude-detail-comparision-grid"
            id="profilePdfColumnHeight"
          >
            <div className="attitude-comparision-float">
              <div className="attitude-float">
                <div className="attitude-comparision-image-border attitude-float">
                  {this.getImageIcon(
                    _.camelCase(
                      this.props.brandDetail.icon.replace('.png', ''),
                    ),
                  ) === undefined && <div className="imageblock" />}
                  {this.getImageIcon(
                    _.camelCase(
                      this.props.brandDetail.icon.replace('.png', ''),
                    ),
                  ) !== undefined && (
                    <img
                      alt=""
                      className="i360-demo-double-comparision-img"
                      src={this.getImageIcon(
                        _.camelCase(
                          this.props.brandDetail.icon.replace('.png', ''),
                        ),
                      )}
                    />
                  )}
                  <div className="attitude-comparision-icon-labels">
                    {this.props.brandDetail.brandCategory}{' '}
                  </div>
                </div>
              </div>
              <div className="profile-matrix-container">
                <div className="div-overflow">
                  <div
                    className="attitude-comparision-labels"
                    id="pdfProfileTriplePersonaLabelHeight"
                    title={this.props.brandDetail.brandLabel}
                  >
                    <p className="block-with-text">
                      {this.props.brandDetail.brandLabel}
                    </p>
                  </div>
                </div>
                <div className="div-overflow">
                  <div className="attitude-triple-comparision-metrics profile-matrix-push-down">
                    <p className="profile-matrix-padding">
                      INDEX:&nbsp;&nbsp;{this.props.brandDetail.index} |
                      REACH:&nbsp;&nbsp;{this.props.brandDetail.pct}{' '}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

}

ProfileTripleComparisionDetail.propTypes = {
  brandDetail: PropTypes.shape({}),
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(ProfileTripleComparisionDetail);
